'use strict';

var HTTPService = require('./http-service');
var NotificationService = require('./notification-service');

var ReviewsService = {
  upvote: function (id) {
    if (!id) {
      return this.tryAgain();
    }
    return HTTPService.put('/api/reviews/' + id + '/upvote', {}).then(this.isAlreadyVoted);
  },

  downvote: function (id) {
    if (!id) {
      return this.tryAgain();
    }
    return HTTPService.put('/api/reviews/' + id + '/downvote', {}).then(this.isAlreadyVoted);
  },

  rate: function (data) {
    if (!data) {
      return this.tryAgain();
    }
    return HTTPService.post('/api/reviews', data);
  },

  loginRequired: function () {
    return NotificationService.warning('Você precisa se logar antes!');
  },

  isAlreadyVoted: function (result) {
    if (result.status === 409) {
      throw new Error('Você já votou nesse comentário');
    }

    return result;
  },

  tryAgain: function (msg) {
    NotificationService.warning(msg || 'Não foi possível contabilizar. Tente novamente.');
  },

  count: function (event) {
    var element = $(event.currentTarget).find('.review-votes-count');
    element.text(+element.text() + 1);
  }
};

module.exports = ReviewsService;
